import { useLocation, useNavigate } from "react-router-dom";


import Sidebar from "../components/dashboard/sidebar";
import Footer from "../pages/Footer";
import DashboardHeader from "../components/dashboard/header";
import Header from "../pages/Header";

import ML from "./Modules/ML";
import UserML from "./Modules/UserML";
import FM from "./Modules/FM";
import DashboardFooter from "../components/dashboard/footer";
import SideMenu from "./student/SideMenu";

const ModuleLibrary = ({type,moduleType=null}) => {
    console.log('moduleTypemoduleTypemoduleTypemoduleType',moduleType)
    const token = localStorage.getItem("token");
   const location = useLocation();
  console.log("Current Pathname:>>>>>>>>>>>>>>>>>>>>>>", location.pathname,type);
    return (
        <>
         <div id="layout-wrapper" className="module-library-db">
                {token ? <DashboardHeader /> : <Header />}
                {token && <SideMenu />}
                {token?  
                <div className={`${token ? "main-content mt-4" : " "} user-management lecture-library mt-4`} id="main-content">
                    <div className="container-fluid" id="container-fluid">
                        <div className="row table-data" id="table-data-row">
                            <div className="col-12">
                                {location.pathname==="/usermoduleslibrary"? <UserML type={type}/>:location.pathname==="/fellowshipmodules"?<FM type={type}/>: location.pathname==="/timedmodule" ? <ML type={type} moduleType={moduleType}/> : location.pathname === "/mcqmoduleslibrary" ? <ML type={type} moduleType={moduleType}/> :<ML type={type}/>}
                                
                            </div>
                        </div>
                    </div>
                </div>:<div className="landing-page-vid">
                    <div className={`${token ? "main-content mt-4" : " "} user-management lecture-library mt-4`} id="main-content">
                    <div className="container-fluid" id="container-fluid">
                        <div className="row table-data" id="table-data-row">
                            <div className="col-12">
                                 {/* {location.pathname==="/usermoduleslibrary"? <UserML type={type}/>:<ML type={type}/>} */}
                                 {location.pathname==="/usermoduleslibrary"? <UserML type={type}/>:location.pathname==="/fellowshipmodules"?<FM type={type}/>: location.pathname==="/timedmodule" ? <ML type={type} moduleType={moduleType}/> : <ML type={type}/>}
                            </div>
                        </div>
                    </div>
                </div>
                    </div>}
              
                {token && <DashboardFooter id="footer" />}
            </div>
            {!token && <Footer id="footer" />}
</>
    );
};

export default ModuleLibrary;